
<template>
  <div>
    <b-button
      v-permission="'contact_lists.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-50"
      />
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid :service="service" route_name="contact-lists">
      <template #actions="actions">
        <feather-icon
          v-permission="`contact_lists.edit`"
          icon="EditIcon"
          class="h-5 w-5 mb-1 mr-1 stroke-current text-warning cursor-pointer"
          v-if="!hide_edit"
          @click="actions.methods.edit(actions.data[actions.indextr].id)"
        />
        <feather-icon
            icon="CopyIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-primary cursor-pointer"
            v-tooltip.top="{
              content: 'Clonar grupo',
              delay: { show: 100, hide: 100 }
            }"
            @click="confirmClone(actions.row.id)"
          />
        <feather-icon
          v-permission="`contact_lists.delete`"
          icon="Trash2Icon"
          class="h-5 w-5 mb-1 mr-1 stroke-current text-danger cursor-pointer"
          v-if="!hide_delete"
          @click="actions.methods.destroy(actions.data[actions.indextr])"
        />
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import ContactListService from '@/services/api/ContactListService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/contact-lists/create')
    },
    confirmClone(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja clonar este grupo?',
        accept: () => {
          this.clone(id)
        }
      })
    },
    clone(id) {
      this.$vs.loading()
      this.service.clone(id).then(
        response => {
          this.$router.push(`/contact-lists/${response.id}/edit`)
          this.notifySuccess(
            this.$vs,
            'Lista clonada com sucesso!',
            2000,
            'center-top'
          )
        }
      ).finally(() => this.$vs.loading.close())
    },
  },
  beforeMount() {
    this.service = ContactListService.build(this.$vs)
  }
}
</script>